import FindMenu from './menusDesktop/FindMenu'
import StartMenu from './menusDesktop/StartMenu'
import LearnMenu from './menusDesktop/LearnMenu'
import AboutUsMenu from './menusDesktop/AboutUsMenu'

type MegaMenuVariant = 'find' | 'start' | 'learn' | 'aboutUs'

export type MegaMenuProps = {
  variant: MegaMenuVariant
}

export const MegaMenu = ({ variant }: MegaMenuProps) => {
  return (
    <div
      style={{
        marginTop: '0.5rem',
        display: 'flex',
        alignItems: 'stretch',
        border: 'var(--border-default)',
        borderRadius: '1.25rem',
        background: 'var(--palette-white)',
        padding: '1.5rem',
        gap: '1.5rem',
        boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.05)',
      }}
    >
      {MenuMap[variant]}
    </div>
  )
}

const MenuMap: Record<MegaMenuVariant, JSX.Element> = {
  find: <FindMenu />,
  start: <StartMenu />,
  learn: <LearnMenu />,
  aboutUs: <AboutUsMenu />,
}
